import {erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {erTomListe} from "felles-ng2/støttefunksjoner/lister";

/** Returnerer sann dersom begge objektene inneholder de samme feltene og deres verdier er like når sammenliknet med ===.
 * MERK at vi IKKE gjør en dyp sammenlikning! Til det formålet kan feks JSON.stringify(a) == JSON.stringify(b) benyttes */
export function erLikeObjekter<T extends Object>(a: T, b: T): boolean {
    if (a === b) return true;
    if (erNil(a) || erNil(b)) return false;
    if (typeof a !== 'object' && typeof b !== 'object') return a === b;

    return Object.keys(a).length === Object.keys(b).length &&
      (Object.keys(a) as (keyof typeof a)[])
        .every((key) => Object.prototype.hasOwnProperty.call(b, key) && a[key] === b[key]);
}

/** Returnerer sann dersom begge objektene er identiske når en dyp sammenlikning gjøres.
 * Sammenlikner den serialiserte representasjonen av objektene (serialisert vhja JSON.stringify) */
export function erLikeObjekterDyp<T>(a: T, b: T): boolean {
    if (a === b) return true;
    if (erNil(a) || erNil(b)) return false;
    return JSON.stringify(a) == JSON.stringify(b);
}

/** Returnerer et nytt objekt med kun valgte felt fra kilden. Også kjent under 'pick() i andre bibliotek.
 * Kunne også ha brukt raadash#pick */
export function kopiMedKunFeltene<T, K extends keyof T>(objekt: T, felt: K[]) {
    return felt.reduce(
      (resultat, verdi) => {
          resultat[verdi] = objekt[verdi];
          return resultat;
      },
      {} as Pick<T, K>);
}

export function erTomtObjekt(objekt: Object | null): boolean {
    if (erNil(objekt)) return true;
    return erTomListe(Object.keys(objekt));
}

export function erIkkeTomtObjekt(objekt: Object | null): boolean {
   return !erTomtObjekt(objekt);
}

/** Returnerer et nytt objekt populert med verdiene fra angitt standardVerdier kombinert med verdiene fra overstyrendeVerdier */
export function kombiner<U, V>(standardVerdier: U, overstyrendeVerdier:V): U & V {
    return Object.assign({}, standardVerdier, overstyrendeVerdier);
}

/** Sann dersom angitt objekt har et felt med angitt navn. Merk at vi ikke støtter nestede strukturer. */
export function harFelt(objekt: any, felt: string) {
    if (erNil(objekt)) return false;
    //Object.hasOwn(kandidat, 'standardIMoete') krever ECMA 2022
    return Object.prototype.hasOwnProperty.call(objekt, felt)
}
